import axios from "axios";
import { ContainerRequest } from "@Base/Engagement/MalachyteRecommendation";

export class EngagementService
{
	public AddGuestAccount = (email: string, phone: string, attentiveEmail: boolean, attentiveSms: boolean): Promise<any> =>
	{
		let url = `/api/engagement/save?email=${email}`;

		if (phone !== "")
		{
			url += `&phone=${phone}`;
		}

		url += `&subscribeAttentiveEmail=${attentiveEmail}`;
		url += `&subscribeAttentiveSms=${attentiveSms}`;

		return axios.post(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public AddSubscription = (phone: string, email: string, subscriptionId: string): Promise<any> =>
	{
		const url = `/api/engagement/addSubscription?phone=${phone}&email=${email}&subscriptionId=${subscriptionId}`;

		return axios.post(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public AddRecommendationClick = (unique: string): Promise<any> =>
	{
		const url = `/api/engagement/recommendationClick?accountGuid=${unique}`;

		return axios.post(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public GetAccountEmailPhone = (): Promise<any> =>
	{
		const url = "/api/engagement/GetAccountEmailPhone";
		return axios.get(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public GetRecentlyViewed = (productId: number): Promise<any> =>
	{
		let url = `/api/recommendation/get-recently-viewed?pdpProductId=${productId}`;

		return axios.get(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public GetRecommendations = (data: ContainerRequest[]): Promise<string> =>
	{
		const url = `/api/malachyte/get-recommendations`;
		return axios.post(url, data)
			.then(response => response.data as string)
			.catch((error) =>
			{
				console.log(error);
				return "";
			});
	};
}